import { Modal, ModalProps } from 'antd';

export type ModalAtomProps = ModalProps;

const ModalAtom = Modal;

export default ModalAtom;
